export type Activity = {
    objectId: string;
    objectTypeId: ObjectType;
    objectName: string;
    activityLogTypeId: ActivityLogType;
    created: string;
    createdBy: string;
};

export enum ActivityLogType {
    CreatedAgreement,
    ModifiedAgreement,
    DeletedAgreement,
    ModifiedAgreementNotifyPeriod,
    ModifiedAgreementValidTo,
    RenewalAgreement,
    ModifiedAgreementTerminated,
    ModifiedAgreementReplaced,
    NewInboxItem,
    CreatedCustomer,
    DeletedCustomer,
    ModifiedCustomer,
    CreatedCounterpart,
    DeletedCounterpart,
    ModifiedCounterpart,
    CreatedUser,
    DeletedUser,
    ModifiedUser,
    MovedUser,
    SentForRenegotiate
}

export enum ObjectType {
    Agreement,
    Customer,
    Counterpart,
    User,
    Inbox
}
